__turbopack_context__.v({
  "className": "fraunces_207a695c-module__XZmYqG__className",
});
